export const DP_REQUESTS_QUERY_KEY = 'dp-requests';

export const dpRequestsKeys = {
    all: [DP_REQUESTS_QUERY_KEY] as const,
    mine: (email: string) => [DP_REQUESTS_QUERY_KEY, 'mine', email] as const,
    queue: () => [DP_REQUESTS_QUERY_KEY, 'queue'] as const,
    manager: (email: string) => [DP_REQUESTS_QUERY_KEY, 'manager', email] as const,
    detail: (requestId: string) => [DP_REQUESTS_QUERY_KEY, 'detail', requestId] as const,
    messages: (requestId: string) => [DP_REQUESTS_QUERY_KEY, 'messages', requestId] as const,
    editableProfile: () => [DP_REQUESTS_QUERY_KEY, 'editable-profile'] as const,
    requestContext: () => [DP_REQUESTS_QUERY_KEY, 'request-context'] as const,
    dayOffStatus: () => [DP_REQUESTS_QUERY_KEY, 'day-off-status'] as const,
    healthPlan: () => [DP_REQUESTS_QUERY_KEY, 'health-plan'] as const,
};
